
let prefix = 'https://secureapp.southeastwater.com.au/hydrotrakapi/api/';

export const environment = {
  apiURL: prefix,
  applicationId: 'client-web', // used to define localStorage variables
  production: true,
  TOASTR_HEADER: 'Hydrotrak',
  MODAL_HEADER: 'Hydrotrak',

  authorizeUrl: prefix + 'token/auth',

  lookupActivationCodeUrl: prefix + 'application/lookupcode',
  activateAccountUrl: prefix + 'application/activate',
  applicationLookupUsernameUrl: prefix + 'application/lookupusername',
  applicationCreateUrl: prefix + 'application',
  applicationLOVsUrl: prefix + 'application',
  applicationValidateRegoUrl: prefix + 'application/validaterego',

  permitDetailsUrl: prefix + 'client/permit',
  permitUpdateUrl: prefix + 'client/permit',
  billingDetailsUrl: prefix + 'client/billing',
  transactionListUrl: prefix + 'client/transactions',
  transactionDownloadUrl: prefix + 'client/transactionscsv',
  vehicleDownloadUrl: prefix + 'client/vehicles-csv',

  waterUsageCreateUrl: prefix + 'client/waterusage',
  changePasswordUrl: prefix + 'client/password',
  removeVehicleUrl: prefix + 'client/vehicle',
  createVehicleUrl: prefix + 'client/vehicle',
  updateVehicleUrl: prefix + 'client/vehicle',

  requestPasswordResetUrl: prefix + 'client/forgot-password',
  validatePasswordResetUrl: prefix + 'client/validate-reset-password',
  confirmPasswordResetUrl: prefix + 'client/reset-password',

  sendEmailToAdminUrl: prefix + 'client/message',
  permitRenewUrl: prefix + 'client/permit/renew',

  uploadFileUrl: prefix + 'client/file',
  downloadFileUrl: prefix + 'client/file',
  fileUpdateCommentUrl: prefix + 'client/file',
  fileListUrl: prefix + 'client/files',
  fileDeleteUrl: prefix + 'client/file',
};
